<template>
	<v-dialog
		v-if="filter"
		v-model="showDialog"
		width="800"
		min-height="400"
		persistent
	>
		<v-card>
			<v-card-title> Add Filter </v-card-title>
			<v-card-text>
				<v-form ref="form">
					<v-btn-toggle
						v-if="!isParent"
						v-model="datasetOrStatic"
						class="d-flex"
						color="primary"
						group
						mandatory
					>
						<v-btn :value="1" class="flex-grow-1">
							<v-icon>mdi-table</v-icon>
							Dataset Field
						</v-btn>
						<v-btn :value="2" class="flex-grow-1"> Static </v-btn>
					</v-btn-toggle>

					<div class="d-flex">
						<v-autocomplete
							v-model="selectedFieldId"
							:items="columns"
							class="mx-1"
							item-text="Label"
							item-value="Id"
							label="Filter Field"
							:rules="[validations.ruleRequired(selectedFieldId)]"
							dense
							outlined
							hide-details="auto"
						/>
						<v-select
							v-model="selectedOperator"
							:items="operators"
							class="mx-1"
							item-text="label"
							item-value="value"
							label="Operator"
							:rules="operatorRule"
							dense
							outlined
							hide-details="auto"
							:disabled="disableOperators"
						/>

						<v-text-field
							v-if="filterHasValue && isStatic"
							v-model="selectedValue"
							clearable
							class="mx-1"
							:rules="valueRule"
							label="Value"
							dense
							outlined
							:disabled="disableValue"
							hide-details="auto"
						/>

						<v-menu v-if="filterHasDateValue && isStatic">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-if="filterHasDateValue"
									:value="selectedValue"
									clearable
									class="mx-1"
									:rules="valueRule"
									label="Value"
									dense
									outlined
									v-bind="attrs"
									v-on="on"
									readonly
									:disabled="disableValue"
									hide-details="auto"
								/>
							</template>
							<v-date-picker
								v-model="dateValue"
								@input="menu = false"
								no-title
								color="green"
							></v-date-picker>
						</v-menu>

						<v-select
							v-if="filterHasBooleanValue && isStatic"
							label="Value"
							v-model="selectedValue"
							dense
							outlined
							:rules="valueRule"
							:items="booleanItems"
							item-text="Text"
							item-value="Id"
						/>
						<v-select
							v-if="filterHasApprovalStatusValue && isStatic"
							label="Value"
							v-model="selectedValue"
							dense
							outlined
							:rules="valueRule"
							:items="approvalStatusItems"
							item-text="Text"
							item-value="Id"
						/>

						<v-autocomplete
							v-if="!isStatic"
							v-model="selectedValueFieldId"
							:items="columns"
							class="mx-1"
							item-text="Label"
							item-value="Id"
							label="Value Field"
							:rules="[
								validations.ruleRequired(selectedValueFieldId),
							]"
							dense
							outlined
							hide-details="auto"
						/>
					</div>
				</v-form>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn @click.stop="onSave" color="primary">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import filterComponentMixin from '../../../../../mixins/filters/filterComponentMixin';
import {
	ConnectorFiltersGetters,
	ConnectorsListGetters,
} from '../../../../../store/getters';
import { ConnectorFiltersActions } from '../../../../../store/actions';
import { gridViewConnectorFilterType } from '../../../../../enums/gridViewConnectorFilterType';
import { mapGetters } from 'vuex';

export default {
	name: 'ConnectorFilterModal',
	props: {
		showDialog: Boolean,
		filter: Object,
		filterType: Number,
	},
	mixins: [filterComponentMixin],
	computed: {
		...mapGetters({
			selectedConnector: [ConnectorFiltersGetters.SELECTED_CONNECTOR],
			columns: [ConnectorsListGetters.GRID_VIEW_FIELDS],
		}),
		isStatic() {
			if (this.datasetOrStatic == 1) return false;
			if (this.datasetOrStatic == 2) return true;
			return false;
		},
		isParent() {
			if (this.filterType == gridViewConnectorFilterType.Parent)
				return true;
			return false;
		},
	},
	watch: {
		datasetOrStatic() {
			this.selectedValue = null;
			this.selectedValueFieldId = null;
		},
	},
	data() {
		return {
			datasetOrStatic: (!this.filter.ValueGridViewFieldId ? 2 : 1) || 1, // 1 Dataset Field   //2 Static
			selectedFieldId: this.filter.FilterGridViewFieldId || null, //this.filter.FieldId || null,
			selectedValueFieldId: this.filter.ValueGridViewFieldId || null,
			selectedOperator: this.filter.FilterOperator || null,
			dateValue: null,
			selectedValue: this.filter.Value || null,
		};
	},
	mounted() {
		if (this.filterType == gridViewConnectorFilterType.Parent) {
			this.datasetOrStatic = 2;
		}
	},
	methods: {
		onFilterChanged() {
			//do nothing;
		},

		onClose() {
			this.$emit('close');
		},

		onSave() {
			let filterItem = {
				GridViewConnectorId: this.selectedConnector.Id,
				FilterGridViewFieldId: this.selectedFieldId,
				ValueGridViewFieldId: this.selectedValueFieldId,
				FilterOperator: this.selectedOperator,
				Value: this.selectedValue,
				GridViewConnectorFilterType: this.filterType,
			};

			let promise = null;

			if (this.filter.Id) {
				filterItem.Id = this.filter.Id;
				promise = this.$store.dispatch(
					ConnectorFiltersActions.UPDATE,
					filterItem
				);
			} else {
				promise = this.$store.dispatch(
					ConnectorFiltersActions.ADD,
					filterItem
				);
			}

			promise.then((success) => {
				if (!success) return;
				this.$emit('close');
			});
		},
	},
};
</script>
